import { render, staticRenderFns } from "./JudgingCriteriaQuestionsEdit.vue?vue&type=template&id=220a6226&scoped=true"
import script from "./JudgingCriteriaQuestionsEdit.vue?vue&type=script&lang=js"
export * from "./JudgingCriteriaQuestionsEdit.vue?vue&type=script&lang=js"
import style0 from "./JudgingCriteriaQuestionsEdit.vue?vue&type=style&index=0&id=220a6226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a6226",
  null
  
)

export default component.exports